<template>
    <div>
        <loader v-if="isloading"></loader>
        <v-card shaped class="pa-4 ma-3">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <v-toolbar-title
                            ><h3>Nuevo asiento</h3></v-toolbar-title
                        >
                    </v-toolbar>

                    <v-form ref="form" v-model="formValid" class="mt-3">
                        <v-row justify="end" style="padding: 20px">
                            <v-btn
                                v-if="asiento.id"
                                @click="saveAsiento"
                                :disabled="isloading"
                                color="success"
                                class="white--text"
                                >Actualizar</v-btn
                            >
                            <v-btn
                                color="red"
                                class="white--text"
                                style="margin-left: 10px"
                                @click="cancelar"
                            >
                                Cancelar
                            </v-btn>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="asiento.tipo_apunte_id"
                                    :items="tipo_asiento"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="Tipo de asiento"
                                    outlined
                                >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="asiento.apunte_predefinido_id"
                                    :items="asiento_predefinido"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="Asiento predefinido"
                                    outlined
                                    @change="selectContacto"
                                >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <!-- <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="asiento.fecha"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="asiento.fecha"
                                            label="Fecha"
                                            append-icon="mdi-calendar"
                                            outlined
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                        </v-text-field>
                                    </template>
                                    <v-date-picker
                                        color="#1d2735"
                                        first-day-of-week="1"
                                        v-model="asiento.fecha"
                                        no-title
                                        scrollable
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="red"
                                            @click="menu = false"
                                            ><strong>Cancelar</strong></v-btn
                                        >
                                        <v-btn
                                            text
                                            color="success"
                                            @click="
                                                $refs.menu.save(asiento.fecha)
                                            "
                                            ><strong>OK</strong></v-btn
                                        >
                                    </v-date-picker>
                                </v-menu> -->

                                <dateSelect
                                    label="Fecha"
                                    v-model="asiento.fecha"
                                    outlined
                                />
                            </v-col>

                            <template v-if="hide_contacto">
                                <template v-if="asiento.cliente_id != null">
                                    <v-col cols="12" md="6">
                                        <clienteSelectVue
                                            :label="'Clientes'"
                                            v-model="asiento.cliente_id"
                                            :value="asiento.cliente_id"
                                            :outlined="true"
                                            :extra="cliente"
                                        >
                                        </clienteSelectVue>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-autocomplete
                                            v-model="asiento.factura_id"
                                            :items="facturas"
                                            item-text="nro"
                                            item-value="id"
                                            label="Facturas"
                                            outlined
                                            @change="setCuentasVentas"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col cols="12" md="6">
                                        <!-- <v-autocomplete
                                            v-model="asiento.proveedor_id"
                                            :items="proveedores"
                                            item-text="nombre"
                                            item-value="id"
                                            label="Proveedor"
                                            outlined
                                            @change="getFacturasEntrantes"
                                        >
                                        </v-autocomplete> -->
                                        <ProveedoresSelectVue
                                            :label="'Proveedor'"
                                            v-model="asiento.proveedor_id"
                                            :value="asiento.cliente_id"
                                            :outlined="true"
                                            :extra="proveedor"
                                        ></ProveedoresSelectVue>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-autocomplete
                                            v-model="
                                                asiento.factura_entrante_id
                                            "
                                            :items="facturas_entrantes"
                                            item-text="id"
                                            item-value="id"
                                            label="Facturas"
                                            outlined
                                            @change="setCuentasCompras"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                </template>
                            </template>
                        </v-row>

                        <v-row justify="center">
                            <v-col cols="12">
                                <multiple-select
                                    :headers="headers_cuentas"
                                    title="Línea de asiento"
                                    :elementos="asiento.cuentas"
                                    width="600px"
                                    show="nombre"
                                    :customFooter="true"
                                    @create="createCuenta"
                                    @delete="deleteCuenta"
                                    @getEstado="updateCuentaS"
                                    @update="updateCuenta"
                                >
                                    <v-row>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                outlined
                                                v-model="
                                                    cuenta.cuenta_contable_id
                                                "
                                                :items="cuentas"
                                                item-text="numero"
                                                item-value="id"
                                                label="Cuenta"
                                                :rules="required_val"
                                                :filter="
                                                    $customFilterVAutocomplete
                                                "
                                            >
                                                <template
                                                    v-slot:selection="data"
                                                >
                                                    {{ data.item.numero }} -
                                                    {{ data.item.partida }}
                                                </template>
                                                <template v-slot:item="data">
                                                    <v-list-item-content>
                                                        {{ data.item.numero }} -
                                                        {{ data.item.partida }}
                                                    </v-list-item-content>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>

                                        <!-- <v-col cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                v-model="cuenta.tag"
                                                label="Tag"
                                            >
                                            </v-text-field>
                                        </v-col> -->
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                v-model="cuenta.debe"
                                                label="Debe"
                                                type="number"
                                                :rules="numberInput"
                                                :disabled="debeDisabled"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                outlined
                                                v-model="cuenta.haber"
                                                label="Haber"
                                                type="number"
                                                :rules="numberInput"
                                                :disabled="haberDisabled"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                outlined
                                                v-model="cuenta.descripcion"
                                                label="Descripción"
                                                :rules="required_val"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </multiple-select>
                            </v-col>

                            <v-col cols="12" v-if="campos_requeridos">
                                <h6 style="color: red; text-align: center">
                                    Edite las líneas generadas automáticamente y
                                    llene los campos requeridos
                                </h6>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="asiento.nota"
                                    label="Nota"
                                    outlined
                                >
                                </v-textarea>
                            </v-col>

                            <!-- <v-col cols="12" md="6">
                                <v-file-input
                                    id="file"
                                    v-model="file"
                                    label="Subir archivo"
                                    name="file"
                                    required
                                    show-size
                                    counter
                                    accept="application/pdf"
                                ></v-file-input>
                            </v-col> -->
                        </v-row>
                    </v-form>

                    <!-- Importes -->
                    <div
                        style="width: 100%"
                        class="d-flex justify-space-between mb-4"
                    >
                        <h3>Importes</h3>
                        <v-btn
                            fab
                            dark
                            small
                            color="blue"
                            @click="
                                asiento.importes.push({
                                    iva: 21,
                                    subtotal: 0,
                                    importe_iva: 0,
                                })
                            "
                        >
                            <v-icon dark> mdi-plus </v-icon>
                        </v-btn>
                    </div>
                    <template v-for="importe in asiento.importes">
                        <div style="width: 100%" class="grid-container">
                            <div class="grid-item">
                                <v-text-field
                                    label="Impuesto (%)"
                                    v-model="importe.iva"
                                    outlined
                                    readonly
                                ></v-text-field>
                            </div>
                            <div class="grid-item">
                                <v-text-field
                                    label="Subtotal"
                                    v-model="importe.subtotal"
                                    outlined
                                ></v-text-field>
                            </div>
                            <div class="grid-item">
                                <v-text-field
                                    label="Valor impuesto"
                                    v-model="importe.importe_iva"
                                    outlined
                                ></v-text-field>
                            </div>
                            <div class="grid-item">
                                <div class="d-flex justify-end">
                                    <v-btn
                                        fab
                                        small
                                        color="error"
                                        class="mt-2"
                                        @click="removeImporte(importe)"
                                    >
                                        <v-icon>mdi-trash-can</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- Botones de acciones -->
                    <v-row style="margin-top: 2rem">
                        <v-col cols="12">
                            <v-btn
                                color="red"
                                class="white--text"
                                @click="cancelar"
                            >
                                Cancelar
                            </v-btn>
                            <v-btn
                                v-if="!asiento.id"
                                @click="saveAsiento"
                                :disabled="isloading"
                                color="success"
                                class="white--text"
                                >Guardar</v-btn
                            >

                            <v-btn
                                v-if="asiento.id"
                                @click="saveAsiento"
                                :disabled="isloading"
                                color="success"
                                class="white--text"
                                >Actualizar</v-btn
                            >

                            <v-btn
                                v-if="asiento.id"
                                @click="deleteAsiento"
                                :disabled="isloading"
                                color="red"
                                class="white--text"
                                >Eliminar</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>

        <!-- <v-dialog max-width="500px" v-model="alertDialog">
            <v-card>
                <v-card-title class="text-h5 aviso">
                    Aviso
                </v-card-title>
                <v-card-text class="mt-3 text-center">
                    {{ alertMessage }}
                    <p style="color: red">¿Esta seguro que desea guardar este asiento contable?</p>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn color="success" @click="saveAsiento">Confirmar</v-btn>
                    <v-btn color="error" @click="alertDialog = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
    </div>
</template>

<script>
import clienteSelectVue from "../../../components/general/clienteSelect.vue";
import ProveedoresSelectVue from "../../../components/general/proveedoresSelect.vue";
import dateSelect from "../../../components/general/dateSelect.vue";
import { currentDay } from "../../../components/general/DateFunctions";
export default {
    props: [
        "id_factura",
        "id_cliente",
        "id_proveedor",
        "extra",
        "id_abono",
        "abono",
        "id_factura_entrante",
    ],
    data() {
        return {
            required_val: [(v) => !!v || "El campo es requerido"],
            numberInput: [(v) => v !== null || "El campo es requerido"],
            tipo_asiento: [],
            asiento_predefinido: [],
            clientes: [],
            proveedores: [],
            // clientes: [],
            provvedores: [],
            headers_cuentas: [
                {
                    text: "Cuenta",
                    value: "cuenta",
                    sortable: false,
                    width: "18%",
                },
                {
                    text: "Descripción",
                    value: "descripcion",
                    sortable: false,
                    width: "30%",
                },
                // { text: "Documento", value: "documento", sortable: false },
                { text: "Debe", value: "debe", sortable: false, width: "20%" },
                {
                    text: "Haber",
                    value: "haber",
                    sortable: false,
                    width: "20%",
                },
                // { text: "Tags", value: "tag", sortable: false },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                    width: "12%",
                },
            ],
            cuentas: [],
            // file: null,
            asiento: {
                id: "",
                tipo_apunte_id: "",
                apunte_predefinido_id: "",
                cliente_id: null,
                factura_id: null,
                proveedor_id: null,
                factura_entrante_id: null,
                nota: null,
                documento: null,
                fecha: currentDay(),
                cuentas: [],
                importes: [],
            },
            cuenta: {
                id: null,
                cuenta_contable_id: null,
                cuenta: null,
                documento: "",
                descripcion: "",
                tag: "",
                debe: 0,
                haber: 0,
            },
            index: -1,
            menu: false,
            hide_contacto: false,
            // show_clientes: true,
            debeDisabled: false,
            haberDisabled: false,
            iva: 0,
            campos_requeridos: false,
            predefinido: null,
            facturas: [],
            facturas_entrantes: [],
            factura: {},
            factura_id: null,

            // Auxiliares
            cliente: {},
            proveedor: {},
            formValid: true,
            alertMessage: "",
            alertDialog: false,
        };
    },
    watch: {
        id_factura: function (val) {
            this.setupFacturaExterna();
        },
        id_factura_entrante: function (val) {
            this.setupFacturaExterna();
        },
        id_abono: function (val) {
            this.setupFacturaExterna();
        },
        // file: function (newVal, oldVal) {
        //     if(newVal) {
        //         this.createBase64File(newVal);
        //     } else {
        //         this.asiento.documento = null;
        //     }
        // },
        "asiento.cliente_id": function (val) {
            this.getFacturas();
        },
        "asiento.proveedor_id": function (val) {
            this.getFacturasEntrantes();
        },
    },
    created() {
        this.init();
        this.getTiposApunte();
        this.getCuentas();
        // this.getClientes()
        this.getProveedores();

        this.rol = localStorage.getItem("role");
    },
    methods: {
        async init() {
            await this.getApuntePredefinido();
            this.setupFacturaExterna();
            
            if (
                this.$route.query.id &&
                this.id_factura == null &&
                this.id_factura_entrante == null
            ) {
                this.getAsiento(this.$route.query.id);
            }
        },

        cancelar() {
            if (this.extra) {
                this.$emit("close");
            } else {
                this.$router.push("/lista-libro-diario");
            }
        },
        setupFacturaExterna() {
            if (this.id_factura != null) {
                this.asiento.factura_id = this.id_factura;
                this.asiento.apunte_predefinido_id = 2;
                this.asiento.tipo_apunte_id = 2;
                this.asiento.cliente_id = this.id_cliente;
                this.asiento.nota = this.extra.nota;
                //this.selectContacto();
                this.setCuentasVentas();
                this.hide_contacto = true;
            }
            if (this.id_factura_entrante != null) {
                this.asiento.factura_entrante_id = this.id_factura_entrante;
                this.asiento.apunte_predefinido_id = 11;
                this.asiento.tipo_apunte_id = 6;
                this.asiento.proveedor_id = this.id_proveedor;
                this.setCuentasCompras();
                this.hide_contacto = true;
            }
        },

        // CRUD de cuenta en la tabla
        createCuenta() {
            this.cuenta.cuenta = this.cuentas.find(
                (element) => element.id == this.cuenta.cuenta_contable_id
            ).numero;

            this.asiento.cuentas.push(JSON.parse(JSON.stringify(this.cuenta)));

            let predefinido = this.asiento_predefinido.find(
                (element) => element.id == this.asiento.apunte_predefinido_id
            );

            this.asiento.cuentas.forEach((element) => {
                if (element.cuenta_contable_id == null) {
                    this.campos_requeridos = true;
                } else {
                    this.campos_requeridos = false;
                }
            });
        },
        updateCuentaS(index) {
            console.log(index);
            this.cuenta = JSON.parse(
                JSON.stringify(this.asiento.cuentas[index])
            );
            this.index = index;

            if (this.cuenta.debe > 0) {
                this.debeDisabled = false;
                this.haberDisabled = true;
            } else {
                this.debeDisabled = true;
                this.haberDisabled = false;
            }
        },
        deleteCuenta(indexo) {
            console.log(indexo);
            if (this.asiento.cuentas_eliminadas == null) {
                this.asiento.cuentas_eliminadas = [];
            }
            if (this.asiento.cuentas[indexo].id != null) {
                this.asiento.cuentas_eliminadas.push(
                    this.asiento.cuentas[indexo].id
                );
            }
            this.asiento.cuentas.splice(indexo, 1);
            //console.log(this.cliente);
        },
        updateCuenta() {
            //console.log("prueba");
            this.cuenta.cuenta = this.cuentas.find(
                (element) => element.id == this.cuenta.cuenta_contable_id
            ).numero;

            this.asiento.cuentas[this.index] = JSON.parse(
                JSON.stringify(this.cuenta)
            );
            this.asiento.cuentas.push({});
            this.asiento.cuentas.pop();
        },

        // Get cuentas contables
        getCuentas() {
            axios.get(`api/get-cuentas`).then(
                (res) => {
                    this.cuentas = res.data.success;
                },
                (res) => {}
            );
        },

        // Get tipos de apunte
        getTiposApunte() {
            axios.get(`api/get-tipos-apunte`).then(
                (res) => {
                    this.tipo_asiento = res.data.success;
                },
                (res) => {}
            );
        },

        // Get tipos de apunte
        async getApuntePredefinido() {
            const res = await axios.get(`api/get-apunte-predefinido`);
            this.asiento_predefinido = res.data.success;
        },

        //CRUD apunte/asiento
        save() {
            this.$refs.form.validate();

            if (!this.formValid) {
                this.alertMessage = "No ha llenado los campos requeridos.";
                this.alertDialog = true;
            } else {
                this.saveAsiento();
            }
        },
        saveAsiento() {
            this.alertDialog = false;
            if (this.asiento.cuentas.length > 0) {
                axios
                    .post("api/save-asiento", this.asiento)
                    .then((res) => {
                        if (this.extra != null) {
                            this.$emit("close");
                        } else {
                            this.$router.push("/lista-libro-diario");
                        }
                    })
                    .catch((error) => {
                        this.$custom_error(error.response.data.error);
                    });
            } else {
                this.$custom_error("No ha agregado ninguna cuenta al asiento");
            }
        },
        getAsiento(asiento_id) {
            axios
                .get(`api/get-asiento/${asiento_id}`)
                .then((res) => {
                    this.asiento = res.data.success;
                    this.cliente = this.asiento.cliente;
                    this.proveedor = this.asiento.proveedor;

                    this.predefinido = this.asiento_predefinido.find(
                        (element) =>
                            element.id == this.asiento.apunte_predefinido_id
                    );
                    if (
                        this.predefinido.descripcion
                            .toLowerCase()
                            .includes("venta")
                    ) {
                        this.hide_contacto = true;
                        // this.contactos = this.clientes;
                        // this.asiento.contacto_id = this.contactos.find(
                        //     (element) => element.id == this.asiento.contacto_id
                        // );
                    } else if (
                        this.predefinido.descripcion
                            .toLowerCase()
                            .includes("compra")
                    ) {
                        this.hide_contacto = true;
                        // this.contactos = this.clientes;
                        // this.asiento.contacto_id = this.contactos.find(
                        //     (element) => element.id == this.asiento.contacto_id
                        // );
                    } else {
                        // this.asiento.contacto_id = null;
                        this.hide_contacto = false;
                    }
                })
                .catch((error) => {
                    this.$custom_error(error.response.data.error);
                });
        },
        deleteAsiento() {
            axios
                .delete(`api/delete-asiento/${this.asiento.id}`)
                .then((res) => {
                    this.$router.push("/lista-libro-diario");
                })
                .catch((error) => {
                    if (error.response.code == 400) {
                        this.$custom_error(error.response.data.error);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },

        // Seleccionar contacto entre clientes y proveedores
        selectContacto() {
            this.predefinido = this.asiento_predefinido.find(
                (element) => element.id == this.asiento.apunte_predefinido_id
            );

            if (this.predefinido.descripcion.toLowerCase().includes("venta")) {
                this.hide_contacto = true;
                // this.show_clientes = true;
                // this.contactos = this.clientes;
                this.asiento.cliente_id = 0;
                this.debeDisabled = false;
                this.haberDisabled = true;

                if (this.asiento.factura_entrante_id != null)
                    this.asiento.factura_entrante_id = null;
            } else if (
                this.predefinido.descripcion.toLowerCase().includes("compra")
            ) {
                this.hide_contacto = true;
                // this.show_clientes = false;
                // this.contactos = this.proveedores;
                this.asiento.cliente_id = null;
                this.debeDisabled = true;
                this.haberDisabled = false;

                if (this.asiento.factura_id != null)
                    this.asiento.factura_id = null;
            } else {
                this.asiento.contacto_id = null;
                this.hide_contacto = false;
                this.asiento.cliente_id = null;

                this.asiento.factura_id = null;
                this.asiento.factura_entrante_id = null;
            }

            let cuenta_iva;
            if (/\d/.test(this.predefinido.descripcion)) {
                cuenta_iva = this.predefinido.descripcion.match(/\d+/g);
                this.iva = cuenta_iva[0];
            } else {
                this.iva = 21;
            }
        },

        // Get proveedores
        getProveedores() {
            axios.get(`api/get-proveedores`).then(
                (res) => {
                    this.proveedores = res.data.data;
                },
                (res) => {}
            );
        },

        // Obtener las facturas relacionadas a los clientes
        getFacturas() {
            axios
                .get(`api/get-facturas-cliente/${this.asiento.cliente_id}`)
                .then(
                    (res) => {
                        this.facturas = res.data.success;
                    },
                    (res) => {}
                );
        },

        // Obtener las facturas relacionadas a los proveedores
        getFacturasEntrantes() {
            axios
                .get(`api/get-facturas-proveedor/${this.asiento.proveedor_id}`)
                .then(
                    (res) => {
                        this.facturas_entrantes = res.data.success;
                    },
                    (res) => {}
                );
        },

        // Llenar las lineas de la tabla cuentas
        setCuentasVentas() {
            this.asiento.cuentas = [];
            if (this.extra != null) {
                this.factura = this.extra;
                this.asiento.fecha = new Date().toISOString().split("T")[0];
            } else {
                this.factura = this.facturas.find(
                    (element) => element.id == this.asiento.factura_id
                );
            }
            this.iva = this.factura.iva ?? 0;
            // const cliente_plata = this.factura.total - this.factura.valor_iva;
            const cliente_plata = this.factura.total;

            let cuenta2 = {
                id: null,
                cuenta_contable_id: this.factura.cuenta_cliente_id,
                cuenta: this.factura.cuenta_cliente,
                documento: "",
                descripcion: "Venta a cliente",
                tag: "",
                debe: this.id_abono != null ? 0 : cliente_plata,
                haber: this.id_abono != null ? this.abono ?? 0 : 0,
            };
            this.asiento.cuentas.push(cuenta2);

            // Se mando a no llenar las lineas con las lineas de la factura
            if (this.factura.lineas != null) {
                this.factura.lineas.forEach((element) => {
                    if (
                        element.descripcion.toLowerCase().includes("anticipo")
                    ) {
                        let cuenta = {
                            id: null,
                            cuenta_contable_id:
                                element.cuenta_contable_anticipo?.id,
                            cuenta: element.cuenta_contable_anticipo?.numero,
                            documento: "",
                            descripcion: element.descripcion,
                            tag: "",
                            debe: this.id_abono != null ? element.total : 0,
                            haber: this.id_abono == null ? element.total : 0,
                        };
                        this.asiento.cuentas.push(cuenta);
                    } else {
                        this.setLineasProducto(element);
                    }
                });
            }

            console.log("factura", this.factura);

            let cuenta3 = {
                id: null,
                cuenta_contable_id: this.factura.cuenta_iva_repercutido_id,
                cuenta: this.factura.cuenta_iva_repercutido,
                documento: "",
                descripcion: "Impuesto " + this.factura.iva + "%",
                tag: "",
                debe: this.id_abono != null ? this.factura.valor_iva : 0,
                haber: this.id_abono == null ? this.factura.valor_iva : 0,
            };
            this.asiento.cuentas.push(cuenta3);
        },
        setCuentasCompras() {
            this.asiento.cuentas = [];
            if (this.extra != null) {
                this.factura = this.extra;
                this.asiento.fecha = new Date().toISOString().split("T")[0];
            } else {
                this.factura = this.facturas_entrantes.find(
                    (element) => element.id == this.asiento.factura_entrante_id
                );
            }

            let cuenta2 = {
                id: null,
                cuenta_contable_id: this.factura.cuenta_proveedor_id,
                cuenta: this.factura.cuenta_proveedor,
                documento: "",
                descripcion: "Compra a proveedor",
                tag: "",
                debe: 0,
                // haber: this.factura.total - this.factura.valor_iva,
                haber: this.factura.total,
            };
            this.asiento.cuentas.push(cuenta2);

            if (this.factura.lineas != null) {
                let cuentas_iva = {};

                // Iterar sobre las líneas de la factura
                this.factura.lineas.forEach((element) => {
                    let cuenta = {
                        id: null,
                        cuenta_contable_id: element.cuenta_producto_id,
                        cuenta: element.cuenta_producto,
                        documento: "",
                        descripcion: element.descripcion,
                        tag: "",
                        debe: element.total,
                        haber: 0,
                    };
                    this.asiento.cuentas.push(cuenta);

                    if (element.iva != null) {
                        let descripcion_iva = element.iva.descripcion ?? 0;

                        // Calcular el valor del IVA de la línea
                        let valor_iva =
                            (element.total * parseInt(descripcion_iva)) / 100;

                        // Verificar si ya existe una cuenta con la misma descripción de IVA
                        if (!cuentas_iva[descripcion_iva]) {
                            // Si no existe, creamos la cuenta inicialmente
                            cuentas_iva[descripcion_iva] = {
                                id: null,
                                cuenta_contable_id:
                                    element.iva.id_cuenta_contable_soportado,
                                cuenta: element.iva.cuenta_contable_soportado
                                    ? element.iva.cuenta_contable_soportado
                                          .numero
                                    : "",
                                documento: "",
                                descripcion:
                                    "Impuesto " + descripcion_iva + "%",
                                tag: "",
                                debe: valor_iva, // Inicializamos con el valor actual de IVA
                                haber: 0,
                            };

                            /*let cuenta_impuesto = {
                                id: null,
                                cuenta_contable_id:
                                    element.iva.id_cuenta_contable_soportado,
                                cuenta: element.iva.cuenta_contable_soportado
                                    ? element.iva.cuenta_contable_soportado.numero
                                    : "",
                                documento: "",
                                descripcion:
                                    "Impuesto " + element.iva.descripcion + "%",
                                tag: "",
                                debe:
                                    (element.total *
                                        parseInt(element.iva.descripcion)) /
                                    100,
                                haber: 0,
                            };
                            this.asiento.cuentas.push(cuenta_impuesto);*/
                        } else {
                            // Si ya existe, sumamos el valor de IVA
                            cuentas_iva[descripcion_iva].debe += valor_iva;
                        }
                    }
                });

                // Convertimos las cuentas de IVA agrupadas en un array y las agregamos al asiento
                Object.values(cuentas_iva).forEach((cuenta_impuesto) => {
                    this.asiento.cuentas.push(cuenta_impuesto);
                });
            }

            /*let cuenta3 = {
                id: null,
                cuenta_contable_id: this.factura.cuenta_iva_soportado_id,
                cuenta: this.factura.cuenta_iva_soportado,
                documento: "",
                descripcion: "Total impuesto",
                tag: "",
                debe: this.factura.valor_iva,
                haber: 0,
            };
            this.asiento.cuentas.push(cuenta3);*/
        },
        setLineasProducto(element) {
            if (element.productos.length > 0) {
                element.productos.forEach((element2) => {
                    let cuenta = {
                        id: null,
                        cuenta_contable_id: element2.cuenta_contable_id,
                        cuenta: element2.cuenta_producto,
                        documento: "",
                        descripcion: element2.producto,
                        tag: "",
                        debe: this.id_abono != null ? element2.precio : 0,
                        haber: this.id_abono == null ? element2.precio : 0,
                    };
                    this.asiento.cuentas.push(cuenta);
                });
            }
        },

        // Remover elemento asiento.importes
        removeImporte(importe) {
            const index = this.asiento.importes.indexOf(importe);
            if (index > -1) {
                this.asiento.importes.splice(index, 1);
            }
        },

        //--------------------------------
        subirArchivo64(data) {
            //console.log(extension);
            let me = this;
            axios
                .post(`api/save-archivo64-cliente`, {
                    id: this.cliente.id,
                    archivo: data.data,
                    nombre: data.nombre,
                    extension: data.extension,
                })
                .then((res) => {
                    me.cliente.archivo = res.data;
                    this.$toast.sucs("Archivo guardado con éxito");
                    clear();
                });
        },

        error(err) {
            console.warn(`ERROR(${err.code}): ${err.message}`);
        },
        subirArchivo(archivo) {
            archivo.append("id", this.cliente.id);
            axios.post(`api/save-archivo-cliente`, archivo).then((res) => {
                this.cliente.archivo = res.data;
            });
        },
        deleteArchivo(archivo) {
            axios.get(`api/deletearchivo/${archivo.id}`).then(
                (res) => {
                    this.cliente.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },
        Validar() {
            axios
                .post("api/validate-cliente", { id: this.$route.query.id })
                .then((res) => {
                    this.$router.go();
                });
        },

        // Convertir el file en base 64
        // createBase64File: function(FileObject) {
        //     const reader = new FileReader();
        //     reader.onload = (event) => {
        //         this.asiento.documento = event.target.result;
        //     }
        //     reader.readAsDataURL(FileObject);
        // },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        subtotal() {
            let subtotal = 0;
            if (this.factura.subtotal != null) {
                subtotal = this.factura.subtotal;
            } else {
            }
            return subtotal;
        },
        valor_iva() {
            let iva = 0;
            if (this.factura.valor_iva != null) {
                iva = this.factura.valor_iva;
            } else {
            }
            return iva;
        },
    },
    components: {
        clienteSelectVue,
        ProveedoresSelectVue,
        dateSelect,
    },
};
</script>
<style scoped>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.grid-container {
    display: grid;
    grid-template-columns: repeat(3, 3.3fr) 0.5fr; /* Tres columnas grandes iguales para los inputs, una más pequeña para el botón */
    gap: 1rem;
}

.grid-item {
    width: 100%;
}

/* En pantallas pequeñas, hacemos dos columnas */
@media (max-width: 768px) {
    .grid-container {
        grid-template-columns: repeat(
            2,
            1fr
        ); /* Dos columnas en pantallas pequeñas */
    }
}
</style>
